import { unloadTool } from '@erikdakoda/tool-set/ai-tools/unloadTool';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(unloadTool);
